export function toText(htmlString) {
  if (!htmlString) return '';

  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');

  function walk(node) {
    let text = '';

    node.childNodes.forEach((child) => {
      if (child.nodeType === Node.TEXT_NODE) {
        text += child.textContent;
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        const tag = child.tagName.toLowerCase();

        // Adiciona quebra de linha para certos elementos de bloco
        if (['br'].includes(tag)) {
          text += '\n';
        }

        if (['p', 'div', 'section', 'article', 'tr'].includes(tag)) {
          text += `${walk(child)}\n`;
        } else if (['td'].includes(tag)) {
          text += `${walk(child)} `;
        } else if (['li'].includes(tag)) {
          text += `- ${walk(child)}\n`;
        } else {
          text += walk(child);
        }
      }
    });

    return text;
  }

  return walk(doc.body).replace(/\n{3,}/g, '\n\n').trim();
}

export function sanitize(htmlString, options = {}) {
  if (!htmlString) return '';

  const {
    allowedTags = [
      'p', 'span', 'div', 'br',
      'strong', 'b', 'i', 'em', 'u', 's',
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'table', 'tr', 'td', 'th',
      'ul', 'ol', 'li',
      'strike', 'sub', 'sup',
    ],
    blockedTags = ['script', 'iframe', 'style', 'object'],
    allowedAttributes = {
      '*': ['align', 'style'],
      th: ['colspan'],
      td: ['colspan', 'rowspan'],
    },
    removeBackgroundStyle = true,
  } = options;

  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');

  doc.body.querySelectorAll('*').forEach((el) => {
    const tag = el.tagName.toLowerCase();

    // Remove the tag if it's not in the allowed list
    // For blocked tags, remove the entire element including its content
    // For other disallowed tags, remove the tag but keep its inner content
    if (!allowedTags.includes(tag)) {
      if (!blockedTags.includes(tag)) {
        el.replaceWith(...el.childNodes);
      }
      return;
    }

    // Build the list of allowed attributes for this tag (including global *)
    const tagSpecificAttrs = allowedAttributes[tag] || [];
    const globalAttrs = allowedAttributes['*'] || [];
    const allowedForTag = new Set([...tagSpecificAttrs, ...globalAttrs]);

    // Remove attributes not in the allowed list
    [...el.attributes].forEach((attr) => {
      const attrName = attr.name.toLowerCase();
      if (!allowedForTag.has(attrName)) {
        el.removeAttribute(attrName);
      }
    });

    // Remove background-related style properties if enabled
    if (removeBackgroundStyle && el.hasAttribute('style')) {
      const style = el.getAttribute('style');
      const newStyle = style
        .split(';')
        .map(s => s.trim())
        .filter(s => !s.toLowerCase().startsWith('background'))
        .join('; ');

      if (newStyle.trim()) {
        el.setAttribute('style', newStyle);
      } else {
        el.removeAttribute('style');
      }
    }
  });

  return doc.body.innerHTML;
}

export function isHTML(str) {
  // return /<\/?[a-z][\s\S]*>/i.test(str);
  const doc = new DOMParser().parseFromString(str, 'text/html');
  return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
}
